module.exports = __webpack_public_path__ + "img/si-ali.a2db8bde.jpg";